import { useTheme } from "@emotion/react";
import {
  Chip,
  createSvgIcon,
  LinearProgress,
  Paper,
  Skeleton,
  SvgIcon,
  Typography,
} from "@mui/material";
import useStyles from "./styles";

import { Box, fontSize, height, width } from "@mui/system";
import { Troubleshoot } from "@mui/icons-material";

export default function CardStatusComponent(params) {
  const {
    cardName,
    CardImage,
    value,
    loss = 0,
    loading = false,
    skeleton = false,
    onClick,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  if (skeleton) {
    return (
      <Paper
        elevation={theme.palette.mode == "dark" ? 0 : 3}
        sx={{
          ...styles.containerPaper,
          background: theme.palette.gradient.cardStatusOverview,
        }}
      >
        <Box sx={styles.containerBodyCard}>
          <Box>
            <Skeleton variant="circular" width={60} height={60} />
          </Box>
          <Box sx={styles.containerData}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
              <Skeleton
                variant="text"
                width={80}
                height={16}
                sx={{ marginBottom: 0 }}
              />
              <Skeleton
                variant="text"
                width={80}
                height={30}
                sx={{ marginTop: 0 }}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <Skeleton variant="text" width={80} height={16} />
              <Skeleton variant="rounded" width={80} height={20} />
            </Box>
          </Box>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={theme.palette.mode == "dark" ? 0 : 3}
      onClick={onClick}
      sx={{
        ...styles.containerPaper,
        ...(onClick ? styles.clickablePaper : {}),
        background: theme.palette.gradient.cardStatusOverview,
      }}
    >
      {loading && <LinearProgress sx={styles.linearProgress} />}
      <Box sx={styles.containerBodyCard}>
        <Box
          sx={{
            ...styles.containerIconCard,
            backgroundColor: `${theme.palette.white.main}0e`,
          }}
        >
          {typeof CardImage === "string" ? (
            <img
              src={CardImage}
              alt={`${cardName || "Card"} Logo`}
              style={{
                width: "35px",
                height: "35px",
                objectFit: "contain",
              }}
            />
          ) : typeof CardImage === "function" ||
            typeof CardImage === "object" ? (
            <CardImage
              style={{
                width: "35px",
                height: "35px",
                objectFit: "",
              }}
            />
          ) : (
            CardImage
          )}
        </Box>
        <Box sx={styles.containerData}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography sx={styles.titleData}>{cardName}</Typography>
            <Typography variant="subtitle2" sx={styles.titleValue}>
              {value?.ping}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Typography sx={styles.titleData}>Packet loss</Typography>
            <Chip
              size="small"
              label={`${(typeof value?.packetLoss === "number"
                ? value.packetLoss
                : 0
              ).toFixed(2)} %`}
              sx={{
                background:
                  theme.palette.mode == "dark"
                    ? ""
                    : theme.palette.tertiary.lighter,
                color:
                  theme.palette.mode == "dark"
                    ? ""
                    : theme.palette.colors.black.medium,
              }}
            />
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
